var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.5C22.6274 28.5 28 23.1274 28 16.5C28 9.87258 22.6274 4.5 16 4.5C9.37258 4.5 4 9.87258 4 16.5C4 23.1274 9.37258 28.5 16 28.5ZM14.1143 12.7288C13.5936 12.2081 12.7494 12.2081 12.2287 12.7288C11.708 13.2495 11.708 14.0937 12.2287 14.6144L14.1143 16.5L12.2287 18.3856C11.708 18.9063 11.708 19.7505 12.2287 20.2712C12.7494 20.7919 13.5936 20.7919 14.1143 20.2712L16 18.3856L17.8856 20.2712C18.4063 20.7919 19.2505 20.7919 19.7712 20.2712C20.2919 19.7505 20.2919 18.9063 19.7712 18.3856L17.8856 16.5L19.7712 14.6144C20.2919 14.0937 20.2919 13.2495 19.7712 12.7288C19.2505 12.2081 18.4063 12.2081 17.8856 12.7288L16 14.6144L14.1143 12.7288Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.8a4178beb749ce6f48fea4dd79f3df41.svg";
export { ForwardRef as ReactComponent };